import Common from '../common'
import { registerModule } from '@/store'
import { NAMESPACE_YUESAO_SERVE } from './config'
export default {
  path: '/yuesao-serve',
  component: Common,
  beforeEnter: async (to, from, next) => {
    const { StoreModule } = await import('./store')
    if (StoreModule) {
      registerModule(NAMESPACE_YUESAO_SERVE, StoreModule)
    }
    next()
  },
  children: [
    {
      //绑定订单
      path: 'bind-order',
      name: 'bind-order',
      component: () => import('./bind-order')
    },
    {
      //服务日志详情
      path: 'log-detail-serve',
      name: 'log-detail-serve',
      component: () => import('./log-detail-serve'),
    },
    {
      //顾客端日志详情
      path: 'log-detail-user',
      name: 'log-detail-user',
      component: () => import('./log-detail-user')
    },
    {
      //添加日志
      path: 'add-log',
      name: 'add-log',
      component: () => import('./add-log')
    },
    {
      //服务日历
      path: 'service-calendar',
      name: 'service-calendar',
      component: () => import('./service-calendar')
    }
  ]
}
